import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  children?: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  return (
    <div className="site-shell min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
}

